import { FloatingPanel, FloatingPanelBaseProps } from '@mews/b2b-ui';

/** @deprecated use plain FloatingPanel instead */
export const AsideDialog: React.FC<Omit<FloatingPanelBaseProps, 'modal' | 'size'>> = ({ actions, ...props }) => (
    <FloatingPanel
        modal
        size="medium"
        actions={actions?.map((action) => ({ ...action, size: action.size ?? 'medium' }))}
        {...props}
    />
);
